import { Doughnut } from "react-chartjs-2";
import {
  Chart as ChartJS,
  RadialLinearScale,
  ArcElement,
  Tooltip,
  Legend,
} from "chart.js";

const DoughnutChartSecondary = () => {
  const data = {
    // labels: ["Red", "Blue",],
    datasets: [
      {
        label: "Red",
        data: [40], // The percentage (first value) and the rest to fill the circle
        backgroundColor: ["#04B085"], // Main color and transparent for rest
        borderColor: "white",
        borderWidth: 0,
        weight: 0.7,
        cutout: "48%", // Creates the center hole for the next dataset
        circumference: 180,
        rotation: -100,
        borderRadius: 200,
        order: 2,
      },
      {
        label: "Blue",
        data: [100], // Data and empty portion for the next ring
        backgroundColor: ["#b2ebd1"],
        borderColor: "white",
        borderWidth: 0,
        weight: 0.7,
        cutout: "60%", // Makes the next ring smaller
        circumference: 200,
        rotation: -100,
        order: 1,
      },
    ],
  }

  const centerTextPlugin = {
    id: "centerText",
    beforeDraw: (chart) => {
      const { width, height, ctx } = chart
      ctx.restore()
      const fontSize = (height / 100).toFixed(2);

      ctx.font = `${fontSize}em font-Apparat font-700`;
      ctx.fillStyle = "#04B085";
      ctx.textBaseline = "middle";
      ctx.textAlign = "center";

      // const textLabel = "Total";
      const textX = width / 2

      // const totalValue = data?.reduce((acc, item) => acc + item.amount, 0);
      // Calculate total from chart data (to ensure reactivity)
      const totalValue = 760

      // Format the total with commas
      const formattedTotalValue = totalValue.toLocaleString()
      // console.log("dataaaaa....", chart.config.data.datasets[0]);
      // console.log("total walveee", totalValue);
      // Text for the total value
      const textValue = totalValue ? `${totalValue}` : ""
      const valueY = height / 1.6 + 10

      ctx.font = `${fontSize}em font-[700] font-Filson`
      ctx.fillStyle = "#04B085"
      ctx.fillText(textValue, textX, valueY)

      ctx.save()
    },
  }

  const options = {
    responsive: true,
    maintainAspectRatio: false, // Disable to let height control take effect
    plugins: {
      legend: {
        position: "top",
      },
      tooltip: {
        enabled: false, // Disable tooltips to prevent hover effect
      },
    },
  }

  return (<div className="w-[180px] h-[160px]">
    <Doughnut
      data={data}
      options={options}
      plugins={[centerTextPlugin]}
    />
  </div>)
}

export default DoughnutChartSecondary;